export function isCheckedOut(params: { checkedOutUserId?: string }): boolean {
  return !!(params.checkedOutUserId);
}

export function isCheckedOutByUser(params: { checkedOutUserId?: string, userId: number | string }): boolean {
  const userIdNum = Number(params.userId);
  return !isNaN(userIdNum) && Number(params.checkedOutUserId) === userIdNum;
}

export function isCheckedOutByOther(params: { checkedOutUserId?: string, userId: number | string }): boolean {
  return isCheckedOut(params) && !isCheckedOutByUser(params);
}